export default "__VITE_ASSET__BZlGvS8f__"